export interface PazaramaOrderProduct {
  barcode: string;
  productName: string;
  quantity: number;
}

export const pazaramaOrderProductFromResponse = (
  responseData: any,
): PazaramaOrderProduct => ({
  barcode: responseData.barcode,
  productName: responseData.product_name,
  quantity: responseData.quantity,
});
